//
import './dev/br11-console';
//
import "./dev/libs/bootstrap";
// 
// import 'bootstrap/dist/css/bootstrap.min.css';
//
import '../scss/main.scss';
//
import './dev/scripts';